<template>
  <div class="flex justify-center items-center flex-1 menu-baar">
    <Dropdown>
      <template #toggler>
        <!-- The name goes straight to the user's dashboard; click.stop keeps the
             parent Dropdown from toggling open on the way there. -->
        <button
          class="profile-name relative flex items-center focus:outline-none text-primary__color font-normal"
          @click.stop="goToDashboard"
        >
          {{ profileLabel }}
        </button>
      </template>

      <DropdownContent>
        <!-- <DropdownItem :link="ROUTES.MANAGE_EVENTS" custom-class="border-b border-border__color__second">Manage Events</DropdownItem> -->
        <!-- <DropdownItem :link="ROUTES.TICKET_ORDERS">Ticket Orders</DropdownItem> -->
        <!-- <DropdownItem link="payments">Payments</DropdownItem> -->
        <!-- <span
          class="menu-hedding border-0 router-link-active router-link-exact-active block my-1 px-4 py-1 text-lg text-primary__color lg__mobile:text-xs lg__mobile:px-2">Seeker
          </span> -->
        <!-- <DropdownItem :link="ROUTES.PROFILE" :param="{ seekerId: id }">Manage Account</DropdownItem> -->
        <span
          class="menu-hedding router-link-active router-link-exact-active block my-1 px-4 py-1 text-lg text-primary__color lg__mobile:text-xs lg__mobile:px-2"
          >Personal
        </span>
        <a href="javascript:;" @click="goToProfile(ROLES.SEEKER)"
          >Manage Account/Events</a
        >
        <DropdownItem
          :link="ROUTES.TICKETS"
          v-if="loggedInUserRole !== ROLES.ORGANIZER"
          >Tickets</DropdownItem
        >

        <span
          v-if="loggedInUserRole != ROLES.SEEKER"
          class="menu-hedding router-link-active router-link-exact-active block my-1 px-4 py-1 text-lg text-primary__color lg__mobile:text-xs lg__mobile:px-2"
          >Business
        </span>
        <a
          href="javascript:;"
          @click="goToProfile(ROLES.ORGANIZATION)"
          v-if="loggedInUserRole != ROLES.SEEKER"
          >Manage Account/Events</a
        >
        <DropdownItem is-button :click-handler="logout" :loader="isLoading"
          >Logout</DropdownItem
        >
      </DropdownContent>
      <DropdownContent v-if="loggedInUserRole === ROLES.PLANNER">
        <DropdownItem
          :link="ROUTES.MANAGE_EVENTS"
          custom-class="border-b border-border__color__second"
          >Manage Events
        </DropdownItem>
        <DropdownItem :link="ROUTES.ATTENDEE">Attendee List</DropdownItem>
        <!-- <DropdownItem link="payments">My Payments</DropdownItem> -->
        <DropdownItem :link="ROUTES.ORGANIZATION" :param="{ organizerId: id }"
          >Planner</DropdownItem
        >
        <DropdownItem is-button :click-handler="logout" :loader="isLoading"
          >Logout</DropdownItem
        >
      </DropdownContent>
    </Dropdown>
  </div>
</template>

<script setup>
import Dropdown from "@/components/common/dropdown/dropdown";
import DropdownContent from "@/components/common/dropdown/dropdown-content";
import DropdownItem from "@/components/common/dropdown/dropdown-item";
import { ROUTES } from "@/utils/constants/routes";
import { ROLES } from "@/utils/constants";
import tokenService from "@/services/token.service";
import { useRouter } from "vue-router";
const router = useRouter();
const props = defineProps({
  loggedInUserRole: String,
  userId: String,
});
const emit = defineEmits(["user-logged-out"]);
const loggedInUser = tokenService.getUser();
const id = loggedInUser._id;

const currentActiveProfile =
  localStorage.getItem("activeProfile") &&
  localStorage.getItem("activeProfile") != ""
    ? localStorage.getItem("activeProfile")
    : loggedInUser?.role === ROLES.ORGANIZATION
    ? ROLES.ORGANIZATION
    : ROLES.SEEKER;
const profileLabel =
  currentActiveProfile === ROLES.ORGANIZATION
    ? loggedInUser?.organization || "Profile"
    : `${loggedInUser?.firstName || ""} ${
        loggedInUser?.lastName || ""
      }`.trim() || "Profile";

//Logout
const logout = () => {
  tokenService.clearStorage();
  router.push({ path: "/" });
  // useToaster("success","","Logout Successfully.")
  localStorage.removeItem("activeProfile");
  localStorage.removeItem("isPurchase");
  localStorage.removeItem("ticketBookings");
  localStorage.removeItem("bookingResponse");
  localStorage.removeItem("purchaseDetails");
  emit("user-logged-out");
};

const goToDashboard = () => {
  const isBusinessDashboard =
    loggedInUser?.role === ROLES.PLANNER ||
    (loggedInUser?.role !== ROLES.SEEKER &&
      currentActiveProfile !== ROLES.SEEKER);

  goToProfile(isBusinessDashboard ? ROLES.ORGANIZATION : ROLES.SEEKER);
};

const goToProfile = (activeProfile) => {
  localStorage.setItem("activeProfile", activeProfile);

  if (activeProfile == ROLES.SEEKER) {
    router.push({ name: ROUTES.ORGANIZER, params: { organizerId: id } });
  } else {
    router.push({ name: ROUTES.ORGANIZATION, params: { organizerId: id } });
  }
};
</script>

<style scoped>
.profile-name {
  cursor: pointer;
  white-space: nowrap;
}

/* Global CSS anchors the dropdown with left:0 which clips it when the Profile
   button is near the right edge of the viewport. Override to right-align so
   the panel opens to the left (standard behaviour for right-side dropdowns). */
.menu-baar :deep(.origin-top-right) {
  left: auto !important;
  right: 0 !important;
}
</style>
